import { Paper, Button, IconButton, Grid, Alert } from "@mui/material";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import React from "react";
import FormLayout from "../../../components/FormLayout";
import EditIcon from "@mui/icons-material/Edit";
import { connect } from "react-redux";
import MaskTextInput from "../../../components/MaskTextInput";
import { MaskTypes } from "../../../utils/models";
import { taxSlice, TaxState } from "../../../store/reducer/tax";
import CustomButton from "../../../components/CustomButton";
import { toDollar, toFloatString, toFloatStringAllowingNegative } from "../../../utils/dataConverter";
import { RootState } from "../../../store";
import { Dispatch } from "redux";
import { TaxDocument } from "../../../model/tax/tax_document";
import { IRS1040Form } from "../../../model/tax/irs1040";
import InfoRounded from "@mui/icons-material/InfoRounded";
import { ValidatorForm } from "react-material-ui-form-validator";
import { ErrorAlert } from "../../../components/Alerts";

interface Confirm1040Props {
  handleOpen: () => void;
  deleteFile: () => void;
  editMode: boolean;
  toggleEditMode: (editMode: boolean) => void;
  taxState: TaxState;
  dispatch: Dispatch;
}

const Confirm1040 = ({
  handleOpen,
  deleteFile,
  editMode,
  toggleEditMode,
  taxState,
  dispatch
}: Confirm1040Props) => {
  const irs1040 = taxState.irs1040;

  return (
    <ValidatorForm onSubmit={() => {
      toggleEditMode(false);
    }}>
      <FormLayout
        title={"Federal Form 1040"}
        subtitle={"Confirm upload"}
        description={`If the amounts you see here don't match what was on your Federal return, click the pencil icon to make corrections before moving to the next step.`}
        icon={<ContactSupportIcon titleAccess="Help" className='help-icon' onClick={handleOpen} />}
      >
        {((irs1040 as TaxDocument<IRS1040Form>)?.warnings ?? {}).uploaded_document?.map((warning: string, index: number) => (
          <ErrorAlert key={`1040-alert-${index}`}>{warning}</ErrorAlert>
        ))}
        <Paper elevation={0} className='file-drop-wrapper shrink'>
          <div className='file-name-header'>
            <h3>
              <strong>1040 U.S. Individual Tax Return</strong>
            </h3>
            <Button onClick={deleteFile}>delete</Button>
            {editMode || (
              <IconButton
                className='edit-btn'
                aria-label="Edit"
                onClick={() => toggleEditMode(true)}
                size="large">
                <EditIcon className='edit-icon' />
              </IconButton>
            )}
          </div>
          {irs1040?.document_name === 'error' ? (
            <Grid className='form-row' size={12}>
              <p>Error while updating: {irs1040.message}</p>
            </Grid>
          ) : (editMode ? (
            <>
              <Grid
                className='form-static'
                size={{
                  xs: 12,
                  md: 8
                }}>
                <MaskTextInput
                  variant="outlined"
                  name="wages_salary_tips"
                  maskType={MaskTypes.Dollar}
                  label="1 Wages, salaries, tips, etc."
                  placeholder=""
                  value={(irs1040 as TaxDocument<IRS1040Form>).form_data.wages_salary_tips}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      taxSlice.actions.update1040ValueChange(
                        {
                          key: "wages_salary_tips",
                          value: toFloatString(e.target.value) ?? '0.0'
                        })
                    )
                  }
                />
              </Grid>
              <Grid
                className='form-static'
                size={{
                  xs: 12,
                  md: 8
                }}>
                <MaskTextInput
                  variant="outlined"
                  name="other_income"
                  maskType={MaskTypes.Dollar}
                  label="8 Other income from Schedule 1"
                  placeholder=""
                  value={(irs1040 as TaxDocument<IRS1040Form>).form_data.other_income}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatch(
                      taxSlice.actions.update1040ValueChange(
                        {
                          key: "other_income",
                          value: toFloatStringAllowingNegative(e.target.value)
                        })
                    )
                  }
                />
              </Grid>
              <Grid className='form-static' size={12}>
                <CustomButton
                  disabled={false}
                  variant="contained"
                  label="Save"
                  disableElevation={true}
                  style={{ width: 191 }}
                  type="submit"
                />
              </Grid>
            </>
          ) : (
            <>
              <div className='form-static'>
                <label className='form-static-title'>
                  1 Wages, salaries, tips, etc.
                </label>
                <label className='form-static-value'>
                  {toDollar((irs1040 as TaxDocument<IRS1040Form>).form_data.wages_salary_tips)}
                </label>
              </div>
              <div className='form-static'>
                <label className='form-static-title'>
                  8 Other income from Schedule 1
                </label>
                <label className='form-static-value'>
                  {toDollar((irs1040 as TaxDocument<IRS1040Form>).form_data.other_income)}
                </label>
              </div>
            </>
          ))}
        </Paper>
      </FormLayout>
    </ValidatorForm>
  );
};

const mapStateToProps = (state: RootState) => {
  return { taxState: state.tax };
}

export default connect(mapStateToProps)(Confirm1040);
